module.exports = __webpack_public_path__ + "static/Aurory-c90af9a7a8a6e203adf103faf255a1c7.jpg";